import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * Previous / page / next under a paged list — the Bills grid's pager, for the
 * lists that fetched page one and stopped there (audit, 2026-09-23: the
 * Customers list showed 50 of 97 accounts under a footer that said 97, and
 * the reset history would have stopped adding up to its footer at 51).
 *
 * Renders nothing while everything fits on the first page, so a short list
 * looks exactly as it always did.
 */
export function ListPager({
  page,
  hasMore,
  onPage,
  previousLabel,
  nextLabel,
}: {
  page: number;
  hasMore: boolean;
  onPage: (page: number) => void;
  previousLabel: string;
  nextLabel: string;
}) {
  if (!hasMore && page <= 1) return null;

  const arrowClass =
    'grid h-7 w-7 place-items-center rounded-control text-content-secondary hover:bg-hover disabled:opacity-40';

  return (
    <div className="flex items-center justify-end gap-2 py-2" data-list-pager>
      <button
        type="button"
        onClick={() => onPage(Math.max(1, page - 1))}
        disabled={page <= 1}
        aria-label={previousLabel}
        className={arrowClass}
      >
        <ChevronLeft className="h-4 w-4 rtl:rotate-180" aria-hidden />
      </button>
      <span className="tabular text-sm text-content-secondary">{page}</span>
      <button
        type="button"
        onClick={() => onPage(page + 1)}
        disabled={!hasMore}
        aria-label={nextLabel}
        className={arrowClass}
      >
        <ChevronRight className="h-4 w-4 rtl:rotate-180" aria-hidden />
      </button>
    </div>
  );
}
